// A11y remediation code Start

jQuery(document).ready(function ($) {
  $('.skip-link[data-cs-role="skip"]').after(
    '<a href="https://www.scoutdesignstudio.com/pages/accessibility-statement" class="skip-link visually-hidden a11yskip">Accessibility Statement</a>'
  );
});

// A11y remediation code Ends




// wave code


$(document).ready(function(){ 

    setTimeout(function(){ 
    // jQuery('img[src*="warning_16x16.svg"]').attr('alt', 'Warning');
    jQuery('.text-overlay__title.h1.block-heading_mHx3DT').remove();
    jQuery('video-component img').attr('alt', '');
    jQuery('.text-column__image.lightly-spaced-row img').attr('alt', '');

    jQuery(function ($) {
        $('h1, h2, h3, h4, h5, h6').filter(function () {
          return $.trim($(this).text()) === '';
        }).remove();
      });


     },
  4000); 
});




jQuery('a[href="mailto:hello@scoutdesignstudio.com"]').attr(
  'aria-label',
  'Email privacy questions to hello@scoutdesignstudio.com, opens in a new tab'
);

jQuery('.text-column__button.small-feature-link').attr(
  'aria-label',
  'Email Us at customerservice@scoutdesignstudio.com, opens in a new tab'
);


